module.exports = __webpack_public_path__ + "static/media/Motorcyk_SSa-R03a_Mil.07f6d9b0.png";